/**
 * P2 Activation marker.
 *
 * Empty-state strings for contractor accountability surfaces use this date
 * to communicate "we don't have history before this point". Per locked spec
 * #7: do NOT synthetic-backfill real metrics. Render an honest empty state.
 */
export const P2_ACTIVATED_AT = "2026-05-05";
export const P2_EMPTY_STATE_LABEL = `Offer data collection started ${P2_ACTIVATED_AT}.`;
